// Traduce un errore di invio WhatsApp (tipicamente un codice Twilio/Meta, es. "63016")
// in "codice — descrizione leggibile". La descrizione è localizzata via i18n (whatsappErrors.*).
// Se l'errore è già testo leggibile (senza codice), lo restituisce così com'è.
type TFn = (key: string, opts?: Record<string, unknown>) => string;

export function whatsappErrorLabel(error: string | null | undefined, t: TFn): string {
  if (!error) return "";
  const raw = String(error).trim();
  const code = raw.match(/\b(\d{3,6})\b/)?.[1];
  if (!code) return raw; // già testo leggibile (es. "Numero non in whitelist…")
  const desc = t(`whatsappErrors.${code}`, { defaultValue: "" });
  if (desc) return `${code} — ${desc}`;
  const generic = t("whatsappErrors.generic", { defaultValue: "" });
  return generic ? `${code} — ${generic}` : code;
}
